import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { fetchFeedbackByTourId } from "@/redux/slices/feedbackSlice";
import { Link } from "react-router-dom";
const TourInfo = ({ bookingInfo, tourInfo }) => {
  const dispatch = useDispatch();
  const { feedbacks, averageRating } = useSelector((state) => state.feedback);

  useEffect(() => {
    console.log(bookingInfo, "bookingFeedback");
    if (bookingInfo) {
      dispatch(fetchFeedbackByTourId(bookingInfo.tourId));
    }
  }, [dispatch, bookingInfo]);
  return (
    <div class="bg-light-200 border border-light p-3 rounded-2 mb-4">
      <div class="d-flex flex-wrap align-items-center justify-content-between ">
        <div class="d-flex flex-wrap align-items-center booking-hotels">
          <Link
            to={`/tour-detail/${bookingInfo.tourId}`}
            class="avatar avatar-lg me-2"
          >
            <img
              src="assets/img/tours/tours-21.jpg"
              alt="image"
              class="img-fluid  rounded-circle"
            />
          </Link>
          <div class="booking-details">
            <h6 class="mb-1">
              <Link to={`/tour-detail/${bookingInfo.tourId}`}>
                {tourInfo.tourName}
              </Link>
            </h6>
            <div class="d-flex flex-wrap align-items-center booking-items">
              <p class="fs-14 text-gray-6 pe-2 border-end border-light d-flex align-items-center me-2 ">
                <i class="isax isax-signpost5 me-2"></i>
                {tourInfo.categoryName}
              </p>
              <p class="fs-14 text-gray-6 pe-2 border-end border-light d-flex align-items-center me-2 ">
                <i class="isax isax-location5 me-1"></i>
                {tourInfo.departureLocation}
              </p>
              <p class="fs-14 text-gray-6 pe-2 border-end border-light d-flex align-items-center me-2 ">
                <span class="badge badge-warning text-gray-9 me-1">
                  {averageRating || 5.0}
                </span>
                ({feedbacks.length} Reviews)
              </p>
            </div>
          </div>
        </div>
        <div>
          <span class="badge badge-info  rounded-pill p-2 fs-10 d-flex align-items-center">
            {bookingInfo.status}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TourInfo;
